<div class="min-h-screen bg-gray-50 py-8 px-4">
  <div class="max-w-4xl mx-auto">
    
    <div class="mb-8">
      <h1 class="text-2xl font-bold text-gray-900">Reversión de Retiro Corporativo</h1>
      <p class="text-gray-600 mt-1">Revertir el retiro de un acuerdo corporativo</p>
    </div>

    <!-- Progress Steps Dinámico -->
    <div class="mb-8">
      <div class="flex items-center justify-between">
        <!-- Flujo simple (mismo proyecto): 5 pasos -->
        <ng-container *ngIf="destinationForm.get('continueInSameProject')?.value">
          <div *ngFor="let step of [1, 2, 3, 4, 5]; let i = index" class="flex items-center" [class.flex-1]="i < 4">
            <div class="flex items-center justify-center w-10 h-10 rounded-full text-sm font-medium"
                 [ngClass]="{
                   'bg-blue-600 text-white': currentStep === step,
                   'bg-green-500 text-white': currentStep > step || (currentStep === resultStep && step < resultStep),
                   'bg-gray-200 text-gray-600': currentStep < step
                 }">
              <span *ngIf="currentStep !== resultStep || step !== resultStep">{{ step }}</span>
              <svg *ngIf="currentStep === resultStep && step === resultStep && operationSuccess" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
              <svg *ngIf="currentStep === resultStep && step === resultStep && !operationSuccess" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </div>
            <span class="ml-2 text-sm font-medium hidden lg:inline" 
                  [ngClass]="{'text-blue-600': currentStep === step, 'text-green-600': currentStep > step, 'text-gray-500': currentStep < step}">
              {{ step === 1 ? 'Seleccionar' : step === 2 ? 'Revisar' : step === 3 ? 'Destino' : step === 4 ? 'Confirmar' : 'Resultado' }}
            </span>
            <div *ngIf="i < 4" class="flex-1 mx-4 h-1 rounded" 
                 [ngClass]="{'bg-green-500': currentStep > step, 'bg-gray-200': currentStep <= step}"></div>
          </div>
        </ng-container>

        <!-- Flujo extendido (nuevo proyecto): 7 pasos -->
        <ng-container *ngIf="!destinationForm.get('continueInSameProject')?.value">
          <div *ngFor="let step of [1, 2, 3, 4, 5, 6, 7]; let i = index" class="flex items-center" [class.flex-1]="i < 6">
            <div class="flex items-center justify-center w-8 h-8 rounded-full text-xs font-medium"
                 [ngClass]="{
                   'bg-blue-600 text-white': currentStep === step,
                   'bg-green-500 text-white': currentStep > step || (currentStep === 7 && step < 7),
                   'bg-gray-200 text-gray-600': currentStep < step
                 }">
              <span *ngIf="currentStep !== 7 || step !== 7">{{ step }}</span>
              <svg *ngIf="currentStep === 7 && step === 7 && operationSuccess" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
              <svg *ngIf="currentStep === 7 && step === 7 && !operationSuccess" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </div>
            <span class="ml-1 text-xs font-medium hidden xl:inline" 
                  [ngClass]="{'text-blue-600': currentStep === step, 'text-green-600': currentStep > step, 'text-gray-500': currentStep < step}">
              {{ step === 1 ? 'Seleccionar' : step === 2 ? 'Revisar' : step === 3 ? 'Destino' : step === 4 ? 'Valor' : step === 5 ? 'Plan' : step === 6 ? 'Confirmar' : 'Resultado' }}
            </span>
            <div *ngIf="i < 6" class="flex-1 mx-2 h-1 rounded" 
                 [ngClass]="{'bg-green-500': currentStep > step, 'bg-gray-200': currentStep <= step}"></div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Paso 1: Buscar -->
    <div *ngIf="currentStep === 1" class="bg-white rounded-xl shadow-sm p-6">
      <h2 class="text-lg font-semibold mb-4">Buscar Empresa con Acuerdos Retirados</h2>
      
      <form [formGroup]="searchForm" (ngSubmit)="searchCompany()" class="mb-6">
        <div class="flex gap-4">
          <input type="text" formControlName="searchTerm" 
                 placeholder="Buscar por nombre o NIT..."
                 class="flex-1 rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
          <button type="submit" [disabled]="searchForm.invalid || isSearching"
                  class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
            {{ isSearching ? 'Buscando...' : 'Buscar' }}
          </button>
        </div>
      </form>

      <div *ngIf="searchPerformed && companies.length > 0" class="space-y-3">
        <div *ngFor="let company of companies" (click)="selectCompany(company)"
             class="p-4 border rounded-lg cursor-pointer hover:bg-blue-50 hover:border-blue-300"
             [ngClass]="{'border-blue-500 bg-blue-50': selectedCompanyId === company.id}">
          <h3 class="font-medium">{{ company.name }}</h3>
          <p class="text-sm text-gray-500">NIT: {{ company.documentId }}</p>
        </div>
      </div>

      <div *ngIf="selectedCompanyId && corporateEnrollments.length > 0" class="mt-6">
        <h3 class="text-md font-medium mb-3">Acuerdos Retirados</h3>
        <div class="space-y-3">
          <div *ngFor="let enrollment of corporateEnrollments" (click)="selectEnrollment(enrollment)"
               class="p-4 border rounded-lg cursor-pointer hover:bg-amber-50 hover:border-amber-300">
            <div class="flex justify-between">
              <div>
                <h4 class="font-medium">{{ enrollment.projectName }}</h4>
                <p class="text-sm text-gray-500">Retirado: {{ enrollment.lastPortfolioMovementDate | date:'dd/MM/yyyy' }}</p>
              </div>
              <span class="px-2 py-1 text-xs bg-red-100 text-red-800 rounded-full h-fit">Retirado</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isLoading" class="text-center py-8">
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    </div>

    <!-- Paso 2: Revisar -->
    <div *ngIf="currentStep === 2 && selectedEnrollment" class="bg-white rounded-xl shadow-sm p-6">
      <h2 class="text-lg font-semibold mb-4">Revisar Acuerdo a Revertir</h2>
      
      <div class="bg-gray-50 rounded-lg p-4 mb-6">
        <div class="grid grid-cols-2 gap-4">
          <div><p class="text-sm text-gray-500">Empresa</p><p class="font-medium">{{ selectedEnrollment.companyName }}</p></div>
          <div><p class="text-sm text-gray-500">Proyecto</p><p class="font-medium">{{ selectedEnrollment.projectName }}</p></div>
          <div><p class="text-sm text-gray-500">Cuotas castigadas</p><p class="font-medium">{{ selectedEnrollment.companyPendingPlans.length + selectedEnrollment.participantPendingPlans.length }}</p></div>
          <div><p class="text-sm text-gray-500">Monto total</p><p class="font-medium">{{ formatCurrency(selectedEnrollment.totalPendingAmount, selectedEnrollment.currencyCode || 'COP') }}</p></div>
        </div>
      </div>

      <p *ngIf="selectedEnrollment.withdrawalReason" class="text-gray-600 mb-4">{{ selectedEnrollment.withdrawalReason }}</p>

      <div class="flex justify-between mt-6">
        <button (click)="prevStep()" class="px-4 py-2 text-gray-600 hover:text-gray-800">Volver</button>
        <button (click)="nextStep()" class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Continuar</button>
      </div>
    </div>

    <!-- Paso 3: Destino -->
    <div *ngIf="currentStep === 3 && selectedEnrollment" class="bg-white rounded-xl shadow-sm p-6">
      <h2 class="text-lg font-semibold mb-6">Seleccionar Destino</h2>
      
      <form [formGroup]="destinationForm">
        <div class="mb-6">
          <label class="flex items-center gap-3 p-4 border rounded-lg cursor-pointer hover:bg-gray-50"
                 [ngClass]="{'border-blue-500 bg-blue-50': destinationForm.get('continueInSameProject')?.value}">
            <input type="radio" formControlName="continueInSameProject" [value]="true" class="text-blue-600">
            <div>
              <p class="font-medium">Continuar en el mismo proyecto</p>
              <p class="text-sm text-gray-500">{{ selectedEnrollment.projectName }}</p>
            </div>
          </label>
          
          <label class="flex items-center gap-3 p-4 border rounded-lg cursor-pointer hover:bg-gray-50 mt-3"
                 [ngClass]="{'border-blue-500 bg-blue-50': !destinationForm.get('continueInSameProject')?.value}">
            <input type="radio" formControlName="continueInSameProject" [value]="false" class="text-blue-600">
            <div class="flex-1">
              <p class="font-medium">Continuar en otro proyecto</p>
              <div *ngIf="!destinationForm.get('continueInSameProject')?.value" class="mt-2">
                <p-dropdown 
                  formControlName="newProjectId" 
                  [options]="projects" 
                  optionLabel="name" 
                  optionValue="id"
                  [filter]="true" 
                  filterBy="name,projectId" 
                  placeholder="Seleccione un proyecto..." 
                  styleClass="w-full"
                  [showClear]="true">
                  <ng-template let-project pTemplate="item">
                    <div class="flex flex-col">
                      <span class="font-medium">{{project.name}}</span>
                      <span class="text-xs text-gray-500">{{project.projectId}}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
          </label>
        </div>
      </form>

      <div class="flex justify-between">
        <button (click)="prevStep()" class="px-4 py-2 text-gray-600 hover:text-gray-800">Volver</button>
        <button (click)="nextStep()" [disabled]="!isDestinationValid()" 
                class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
          Continuar
        </button>
      </div>
    </div>

    <!-- Paso 4 (Mismo Proyecto): Confirmar -->
    <div *ngIf="currentStep === 4 && selectedEnrollment && destinationForm.get('continueInSameProject')?.value" class="bg-white rounded-xl shadow-sm p-6">
      <h2 class="text-lg font-semibold mb-6">Confirmar Reversión</h2>
      
      <div class="bg-gray-50 rounded-lg p-4 mb-6">
        <div class="grid grid-cols-2 gap-4 text-sm">
          <div><span class="text-gray-500">Empresa:</span><span class="ml-2 font-medium">{{ selectedEnrollment.companyName }}</span></div>
          <div><span class="text-gray-500">Proyecto:</span><span class="ml-2 font-medium">{{ selectedEnrollment.projectName }}</span></div>
          <div><span class="text-gray-500">Monto total:</span><span class="ml-2 font-medium text-green-600">{{ formatCurrency(selectedEnrollment.totalPendingAmount, selectedEnrollment.currencyCode || 'COP') }}</span></div>
        </div>
      </div>

      <form [formGroup]="confirmForm" (ngSubmit)="submitReversal()">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-2">Razón de la reversión *</label>
          <textarea formControlName="reason" rows="3" placeholder="Describa la razón..."
                    class="w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"></textarea>
        </div>
        
        <div class="mb-6">
          <label class="block text-sm font-medium text-gray-700 mb-2">Notas adicionales</label>
          <textarea formControlName="notes" rows="2" class="w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"></textarea>
        </div>

        <div class="flex justify-between">
          <button type="button" (click)="prevStep()" class="px-4 py-2 text-gray-600 hover:text-gray-800">Volver</button>
          <div class="flex gap-3">
            <button type="button" (click)="cancel()" class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">Cancelar</button>
            <button type="submit" [disabled]="confirmForm.invalid || isSubmitting"
                    class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50">
              {{ isSubmitting ? 'Procesando...' : 'Confirmar Reversión' }}
            </button>
          </div>
        </div>
      </form>
    </div>

    <!-- Paso 4 (Nuevo Proyecto): Valor -->
    <div *ngIf="currentStep === 4 && selectedEnrollment && !destinationForm.get('continueInSameProject')?.value" class="bg-white rounded-xl shadow-sm p-6">
      <h2 class="text-lg font-semibold mb-4">Valor de la Nueva Inscripción</h2>
      <p class="text-gray-600 mb-6">Define el valor para el proyecto <strong>{{ getSelectedProject()?.name }}</strong></p>

      <!-- Referencia de valores del proyecto -->
      <div class="bg-gray-50 p-4 rounded-lg mb-6">
        <p class="text-sm text-gray-500 mb-2">Valores base del proyecto seleccionado:</p>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <span class="text-gray-600 text-sm">COP:</span>
            <span class="font-medium ml-2">{{ formatCurrency(getSelectedProject()?.inscriptionAmountCOP || getSelectedProject()?.inscriptionAmount || 0, 'COP') }}</span>
          </div>
          <div>
            <span class="text-gray-600 text-sm">USD:</span>
            <span class="font-medium ml-2">{{ formatCurrency(getSelectedProject()?.inscriptionAmountUSD || 0, 'USD') }}</span>
          </div>
        </div>
        <button type="button" (click)="autofillFromProject()" 
                class="mt-3 text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
          Usar valores del proyecto
        </button>
      </div>

      <!-- Referencia del valor castigado original -->
      <div class="bg-red-50 p-4 rounded-lg mb-6 border-l-4 border-red-400">
        <p class="text-sm text-red-700">
          <strong>Valor castigado original:</strong> {{ formatCurrency(selectedEnrollment.totalPendingAmount, selectedEnrollment.currencyCode || 'COP') }}
        </p>
      </div>

      <form [formGroup]="valueForm">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Valor en COP *</label>
            <input type="text" formControlName="newTotalValueCOP" appCurrencyFormatter
                   class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                   placeholder="$ 0">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Valor en USD</label>
            <input type="text" formControlName="newTotalValueUSD" appCurrencyFormatter
                   class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                   placeholder="USD$ 0">
          </div>
        </div>

        <div class="mb-6">
          <label class="block text-sm font-medium text-gray-700 mb-1">Moneda principal para las cuotas</label>
          <p-dropdown 
            formControlName="currencyId"
            [options]="[{label: 'COP - Pesos Colombianos', value: 1}, {label: 'USD - Dólares Estadounidenses', value: 2}]"
            optionLabel="label"
            optionValue="value"
            styleClass="w-full"
            placeholder="Seleccionar moneda">
          </p-dropdown>
          <p class="text-sm text-gray-500 mt-1">Las cuotas del plan de pagos se calcularán en esta moneda.</p>
        </div>
      </form>

      <div class="flex justify-between mt-6">
        <button (click)="prevStep()" class="px-4 py-2 text-gray-600 hover:text-gray-800">Volver</button>
        <button (click)="nextStep()" [disabled]="getActiveTotal() <= 0"
                class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
          Continuar
        </button>
      </div>
    </div>

    <!-- Paso 5 (Nuevo Proyecto): Plan de Pagos -->
    <div *ngIf="currentStep === 5 && selectedEnrollment && !destinationForm.get('continueInSameProject')?.value" class="bg-white rounded-xl shadow-sm p-6">
      <h2 class="text-lg font-semibold mb-4">Configurar Plan de Pagos</h2>

      <div class="bg-gray-50 p-4 rounded-lg mb-6">
        <div class="flex justify-between items-center">
          <span class="font-medium">Valor total de la inscripción:</span>
          <span class="text-xl font-bold text-green-600">
            {{ valueForm.get('currencyId')?.value === 1 ? formatCurrency(parseAmount(valueForm.get('newTotalValueCOP')?.value), 'COP') : formatCurrency(parseAmount(valueForm.get('newTotalValueUSD')?.value), 'USD') }}
          </span>
        </div>
      </div>

      <div class="flex justify-between items-center mb-4">
        <span class="text-sm text-gray-600">{{ newPaymentPlan.length }} cuota(s) configuradas</span>
        <button type="button" (click)="openRefinanceModal()"
                class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
          Generar Automáticamente
        </button>
      </div>

      <div class="overflow-x-auto mb-4">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cuota</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fecha Vencimiento</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Monto</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr *ngFor="let plan of newPaymentPlan; let i = index">
              <td class="px-4 py-3 text-sm font-medium text-gray-900">{{ plan.installmentNumber }}</td>
              <td class="px-4 py-3">
                <p-calendar 
                  [(ngModel)]="plan.dueDate" 
                  dateFormat="dd/mm/yy" 
                  [showIcon]="true" 
                  appendTo="body"
                  styleClass="w-full">
                </p-calendar>
              </td>
              <td class="px-4 py-3">
                <input type="text" [(ngModel)]="plan.amount" appCurrencyFormatter
                       class="w-32 px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              </td>
              <td class="px-4 py-3">
                <button type="button" (click)="removeInstallment(i)" [disabled]="newPaymentPlan.length <= 1"
                        class="text-red-600 hover:text-red-800 disabled:text-gray-400 disabled:cursor-not-allowed">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <button type="button" (click)="addInstallment()"
              class="mb-4 text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
        </svg>
        Agregar Cuota
      </button>

      <div class="p-4 rounded-lg mb-6" [ngClass]="isPlanValid ? 'bg-green-50' : 'bg-red-50'">
        <div class="flex justify-between items-center">
          <span class="font-medium" [ngClass]="isPlanValid ? 'text-green-700' : 'text-red-700'">Total del plan:</span>
          <span class="text-xl font-bold" [ngClass]="isPlanValid ? 'text-green-600' : 'text-red-600'">
            {{ valueForm.get('currencyId')?.value === 1 ? formatCurrency(currentPlanTotal, 'COP') : formatCurrency(currentPlanTotal, 'USD') }}
          </span>
        </div>
        <p *ngIf="!isPlanValid" class="text-sm text-red-600 mt-1">
          El total debe coincidir con el valor de inscripción ({{ valueForm.get('currencyId')?.value === 1 ? formatCurrency(getActiveTotal(), 'COP') : formatCurrency(getActiveTotal(), 'USD') }})
        </p>
      </div>

      <div class="flex justify-between">
        <button (click)="prevStep()" class="px-4 py-2 text-gray-600 hover:text-gray-800">Volver</button>
        <button (click)="nextStep()" [disabled]="!isPlanValid"
                class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
          Continuar
        </button>
      </div>
    </div>

    <!-- Paso 6 (Nuevo Proyecto): Confirmar -->
    <div *ngIf="currentStep === 6 && selectedEnrollment && !destinationForm.get('continueInSameProject')?.value" class="bg-white rounded-xl shadow-sm p-6">
      <h2 class="text-lg font-semibold mb-6">Confirmar Reversión</h2>
      
      <div class="bg-gray-50 rounded-lg p-4 mb-6">
        <div class="grid grid-cols-2 gap-4 text-sm">
          <div><span class="text-gray-500">Empresa:</span><span class="ml-2 font-medium">{{ selectedEnrollment.companyName }}</span></div>
          <div><span class="text-gray-500">Proyecto original:</span><span class="ml-2 font-medium">{{ selectedEnrollment.projectName }}</span></div>
          <div><span class="text-gray-500">Nuevo proyecto:</span><span class="ml-2 font-medium text-blue-600">{{ getSelectedProject()?.name }}</span></div>
          <div><span class="text-gray-500">Valor COP:</span><span class="ml-2 font-medium">{{ formatCurrency(parseAmount(valueForm.get('newTotalValueCOP')?.value), 'COP') }}</span></div>
          <div><span class="text-gray-500">Valor USD:</span><span class="ml-2 font-medium">{{ formatCurrency(parseAmount(valueForm.get('newTotalValueUSD')?.value), 'USD') }}</span></div>
          <div><span class="text-gray-500">Cuotas:</span><span class="ml-2 font-medium">{{ newPaymentPlan.length }}</span></div>
        </div>
      </div>

      <form [formGroup]="confirmForm" (ngSubmit)="submitReversal()">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-2">Razón de la reversión *</label>
          <textarea formControlName="reason" rows="3" placeholder="Describa la razón..."
                    class="w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"></textarea>
        </div>
        
        <div class="mb-6">
          <label class="block text-sm font-medium text-gray-700 mb-2">Notas adicionales</label>
          <textarea formControlName="notes" rows="2" class="w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"></textarea>
        </div>

        <div class="flex justify-between">
          <button type="button" (click)="prevStep()" class="px-4 py-2 text-gray-600 hover:text-gray-800">Volver</button>
          <div class="flex gap-3">
            <button type="button" (click)="cancel()" class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">Cancelar</button>
            <button type="submit" [disabled]="confirmForm.invalid || isSubmitting"
                    class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50">
              {{ isSubmitting ? 'Procesando...' : 'Confirmar Reversión' }}
            </button>
          </div>
        </div>
      </form>
    </div>

    <!-- Paso de Resultado (5 para mismo proyecto, 7 para nuevo proyecto) -->
    <div *ngIf="currentStep === resultStep" class="bg-white rounded-xl shadow-sm p-6">
      <div *ngIf="operationSuccess" class="text-center py-8">
        <div class="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
          <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
          </svg>
        </div>
        <h2 class="text-xl font-semibold mb-2">Reversión Procesada Exitosamente</h2>
        <p class="text-gray-600 mb-6">{{ operationResult?.message }}</p>
        
        <div class="bg-gray-50 rounded-lg p-4 text-left mb-6 max-w-md mx-auto">
          <div class="space-y-2 text-sm">
            <div class="flex justify-between"><span class="text-gray-500">Empresa:</span><span class="font-medium">{{ selectedEnrollment?.companyName }}</span></div>
            <div class="flex justify-between" *ngIf="operationResult?.newCorporateEnrollmentId"><span class="text-gray-500">Nuevo Acuerdo:</span><span class="font-medium text-blue-600">#{{ operationResult?.newCorporateEnrollmentId }}</span></div>
            <div class="flex justify-between"><span class="text-gray-500">Cuotas Revertidas:</span><span class="font-medium text-green-600">{{ operationResult?.affectedInstallmentsCount }}</span></div>
            <div class="flex justify-between"><span class="text-gray-500">Monto Total:</span><span class="font-bold text-green-600">{{ formatCurrency(operationResult?.totalAffectedAmount || 0, selectedEnrollment?.currencyCode || 'COP') }}</span></div>
          </div>
        </div>
        
        <div class="flex justify-center gap-3">
          <button (click)="goToEnrollmentsList()" class="px-4 py-2 border border-gray-300 rounded-lg">Volver a inscripciones</button>
          <button (click)="startNewReversal()" class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Nueva reversión</button>
        </div>
      </div>

      <div *ngIf="!operationSuccess" class="text-center py-8">
        <div class="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
          <svg class="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </div>
        <h2 class="text-xl font-semibold mb-2">Error al Procesar</h2>
        <p class="text-gray-600 mb-6">{{ operationError }}</p>
        <div class="flex justify-center gap-3">
          <button (click)="goToEnrollmentsList()" class="px-4 py-2 border border-gray-300 rounded-lg">Volver</button>
          <button (click)="currentStep = confirmationStep" class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Intentar de nuevo</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Refinanciación -->
  <div *ngIf="showRefinanceModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
      <h3 class="text-lg font-semibold mb-4">Generar Plan de Pagos</h3>
      
      <div class="mb-6">
        <label class="block text-sm font-medium text-gray-700 mb-2">Número de cuotas</label>
        <input type="range" [(ngModel)]="refinanceInstallments"
               [min]="minInstallments" [max]="maxInstallments" class="w-full">
        <div class="flex justify-between text-sm text-gray-500 mt-1">
          <span>{{ minInstallments }}</span>
          <span class="font-medium text-lg text-blue-600">{{ refinanceInstallments }}</span>
          <span>{{ maxInstallments }}</span>
        </div>
      </div>

      <div class="bg-gray-50 p-4 rounded-lg mb-6">
        <div class="flex justify-between text-sm">
          <span class="text-gray-600">Valor por cuota (estimado):</span>
          <span class="font-medium">{{ formatCurrency(getActiveTotal() / refinanceInstallments, valueForm.get('currencyId')?.value === 1 ? 'COP' : 'USD') }}</span>
        </div>
      </div>

      <div class="flex justify-end gap-3">
        <button (click)="closeRefinanceModal()" class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
          Cancelar
        </button>
        <button (click)="confirmRefinance()" class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
          Generar
        </button>
      </div>
    </div>
  </div>
</div>
